import {
  changeFieldValueAndUpdate,
  getFormValue,
  setQuestionVisibility,
} from 'app/services/businessFunctionHelpers';
import { FieldsEnum, FormsEnum } from 'app/shared/enums';

const childrenDetails = {
  checkoutOwnerChildrenCountChange() {
    const hasChildren = getFormValue(
      FieldsEnum.OwnerHasChildren,
      FormsEnum.CheckoutForm
    );

    if (!hasChildren) {
      changeFieldValueAndUpdate(
        FieldsEnum.OwnerOldestChildAge,
        null,
        FormsEnum.CheckoutForm
      );
    }

    setQuestionVisibility({
      key: FieldsEnum.OwnerOldestChildAge,
      visible: hasChildren,
      formName: FormsEnum.CheckoutForm,
    });
  },
};

export default childrenDetails;
